import React from "react";
import "./index.css";

// loader for an initial request
const GOILoader = () => {
  return (
    <div className="goi-loader-wrapper">
      <div className="goi-loader"></div>
    </div>
  );
};

export default GOILoader;
